import "./App.css";
import GameBoard from "./components/GameBoard/GameBoard";

const App = () => {
  return (
    <div className="App">
      <GameBoard />
    </div>
  );
};

export default App;
